import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, ChevronDown, Type } from "lucide-react";
import { LANGUAGES, BIBLE_TRANSLATIONS, useLang } from "@/lib/i18n";
import { T } from "@/constants/testIds";

export default function UtilityBar() {
  const { lang, setLang, translation, setTranslation } = useLang();
  const [q, setQ] = useState("");
  const nav = useNavigate();

  const submitSearch = (e) => {
    e.preventDefault();
    if (q.trim()) nav(`/search?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <div data-testid={T.utilityBar} className="w-full bg-ink text-background/85 text-[12px] tracking-wide border-b border-background/10">
      <div className="container-editorial flex items-center justify-between gap-4 py-2">
        <div className="flex items-center gap-4 min-w-0">
          <span className="hidden sm:inline-flex items-center gap-2.5 min-w-0">
            <span className="h-1.5 w-1.5 rounded-full bg-gold shrink-0" />
            <span className="font-serif italic text-[13px] text-background/75 truncate">
              “This is eternal life, that they know You…” <span className="not-italic text-gold/90 font-sans text-[11px] tracking-widest uppercase ml-1">John 17:3</span>
            </span>
          </span>
        </div>
        <div className="flex items-center gap-2 sm:gap-4">
          <label className="relative inline-flex items-center gap-1" data-no-translate>
            <span className="sr-only">Language</span>
            <select
              data-testid={T.langSelector}
              value={lang}
              onChange={(e) => setLang(e.target.value)}
              className="appearance-none bg-transparent pr-6 pl-1 py-1 border border-background/20 uppercase text-[11px] tracking-widest hover:border-gold cursor-pointer"
            >
              {LANGUAGES.map((l) => (
                <option key={l.code} value={l.code} className="bg-ink text-background">
                  {l.nativeLabel}
                </option>
              ))}
            </select>
            <ChevronDown className="h-3 w-3 absolute right-1 pointer-events-none" />
          </label>
          <label className="relative inline-flex items-center gap-1" data-no-translate>
            <span className="sr-only">Bible translation</span>
            <select
              data-testid={T.bibleTranslationSelector}
              value={translation}
              onChange={(e) => setTranslation(e.target.value)}
              className="appearance-none bg-transparent pr-6 pl-1 py-1 border border-background/20 uppercase text-[11px] tracking-widest hover:border-gold cursor-pointer"
              title="Bible translation"
            >
              {BIBLE_TRANSLATIONS.map((t) => (
                <option key={t.code} value={t.code} className="bg-ink text-background">
                  {t.code}
                </option>
              ))}
            </select>
            <ChevronDown className="h-3 w-3 absolute right-1 pointer-events-none" />
          </label>
          <form onSubmit={submitSearch} className="hidden md:flex items-center gap-1 border border-background/20 pl-2">
            <Search className="h-3.5 w-3.5 opacity-70" />
            <input
              data-testid={T.searchInput}
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search"
              className="bg-transparent outline-none py-1 w-32 text-[12px] placeholder:text-background/50"
              aria-label="Search"
            />
            <button data-testid={T.searchSubmit} className="px-2 uppercase text-[11px] hover:text-gold" type="submit">
              Go
            </button>
          </form>
          <Link
            data-testid={T.elderLoginLink}
            to="/elder-login"
            className="uppercase text-[11px] tracking-widest hover:text-gold"
          >
            Elder Login
          </Link>
        </div>
      </div>
    </div>
  );
}
